<template>
  <section>
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random" extended>
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title>{{ $route.name }}</v-toolbar-title>
      <v-spacer/>
      <template v-slot:extension class="xx">
        <v-btn small color="primary" class="box-shadow" @click="setToday">Today</v-btn>
        <v-spacer/>
        <v-btn small text @click="$refs.workingHoursCalendar.prev()">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title class="mx-3">
          {{ $moment(focus).format('MMMM YYYY') }}
        </v-toolbar-title>
        <v-btn small text @click="$refs.workingHoursCalendar.next()">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-spacer/>

        <v-toolbar-items style="height: auto">
          <v-select
              v-model="type"
              :items="type_options"
              item-text="label"
              item-value="value"
              menu-props="auto"
              hide-details
              single-line
              outlined
              dense
          ></v-select>
        </v-toolbar-items>
      </template>
    </v-toolbar>

<!--    <v-toolbar color="white" class="box-shadow">-->
<!--      <v-btn color="primary" class="box-shadow" @click="setToday">Today</v-btn>-->
<!--      <v-spacer/>-->
<!--      <v-btn text @click="$refs.workingHoursCalendar.prev()">-->
<!--        <v-icon>mdi-chevron-left</v-icon>-->
<!--      </v-btn>-->
<!--      <v-toolbar-title class="mx-3">-->
<!--        {{ $moment(focus).format('MMMM YYYY') }}-->
<!--      </v-toolbar-title>-->
<!--      <v-btn text @click="$refs.workingHoursCalendar.next()">-->
<!--        <v-icon>mdi-chevron-right</v-icon>-->
<!--      </v-btn>-->
<!--      <v-spacer/>-->

<!--      <v-toolbar-items style="height: auto">-->
<!--        <v-select-->
<!--            v-model="type"-->
<!--            :items="type_options"-->
<!--            item-text="label"-->
<!--            item-value="value"-->
<!--            menu-props="auto"-->
<!--            hide-details-->
<!--            single-line-->
<!--            outlined-->
<!--            dense-->
<!--        ></v-select>-->
<!--      </v-toolbar-items>-->
<!--    </v-toolbar>-->

    <v-container fluid>
      <v-card>
        <v-calendar ref="workingHoursCalendar"
                    :now="today"
                    :type="type"
                    v-model="focus"
                    color="primary"
                    :events="events"
                    :event-color="getEventColor"
                    :interval-minutes="90"
                    :interval-count="16"
                    :interval-height="40"
                    @click:more="viewMore"
                    @click:date="viewMore"
                    @click:day="viewMore"
                    @change="loadEvents"
        >
          <template v-slot:event="event">
            <v-hover v-slot:default="{ hover }">
              <div v-if="!hover" class="d-flex align-center justify-center" style="width: 100%; height: 100%">
                <span>{{ event.event.time_start }} - {{ event.event.time_end }}</span>
              </div>

              <div v-else class="d-flex align-center justify-center"
                   @click="openSelectedItemDialog(event)" style="background-color: red; width: 100%; height: 100%">
                <span>{{ event.event.time_start }} - {{ event.event.time_end }}</span>
                <v-icon size="sm" color="white" v-text="'mdi-pencil'"></v-icon>
              </div>
            </v-hover>
          </template>
          <template v-slot:interval="interval">
            <v-hover v-slot:default="{ hover }">
              <div v-if="hover" @click="openCreateItemDialog(interval)"
                   class="d-flex align-center justify-center"
                   style="width: 100%; height: 100%; cursor: pointer">
                <v-icon v-text="'mdi-plus'"></v-icon>
              </div>
              <div v-else class="" @click="openCreateItemDialog(interval)" style="width: 100%; height: 100%"/>
            </v-hover>
          </template>
        </v-calendar>
      </v-card>
      <v-dialog max-width="500px" v-model="create_item_dialog" @click:outside="closeCreateItemDialog">
        <v-form v-if="create_item" @submit="saveCreateItem">
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="closeCreateItemDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Settings</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text type="submit">Save</v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-subheader>UK Time zone</v-subheader>
            <v-divider/>
            <v-card-text>
              <v-text-field label="Start" :value="create_item.time_start" disabled/>
              <v-text-field label="End" :value="create_item.time_end" disabled/>

              <v-select label="Repeat" v-model="create_item.repeat" :items="repeat_options"
                        item-color="success"></v-select>
              <template v-if="create_item.repeat != 'no_repeat'">
                <date-field label="Repeat from" v-model="create_item.repeat_start"/>
                <date-field label="Repeat to" v-model="create_item.repeat_end"/>
              </template>

            </v-card-text>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog max-width="500px" v-model="selected_item_dialog" @click:outside="closeSelectedItemDialog">
        <v-card v-if="selected_item">
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeSelectedItemDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Settings</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-menu transition="slide-y-transition" bottom v-if="selected_item.repeat !== 'no_repeat'">
                <template v-slot:activator="{ on }">
                  <v-btn dark text v-on="on">Delete</v-btn>
                </template>
                <v-list>
                  <v-list-item @click="deleteSelectedItem('current')">
                    <v-list-item-title>This interval</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deleteSelectedItem('current_and_next')">
                    <v-list-item-title>This and following intervals</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deleteSelectedItem('all')">
                    <v-list-item-title>All interval instances</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-btn dark text v-if="selected_item.repeat === 'no_repeat'"
                     @click="deleteSelectedItem('all')">Delete</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-subheader>UK Time zone</v-subheader>
          <v-divider/>
          <v-card-text>
            <v-text-field label="Start" :value="selected_item.time_start" disabled/>
            <v-text-field label="End" :value="selected_item.time_end" disabled/>

            <v-select label="Repeat" v-model="selected_item.repeat" :items="repeat_options" disabled/>
            <template v-if="selected_item.repeat !== 'no_repeat'">
              <date-field label="Repeat start" v-model="selected_item.repeat_start" disabled/>
              <date-field label="Repeat end" v-model="selected_item.repeat_end" disabled/>
            </template>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </section>
</template>

<script>
import DateField from "@/components/DateField";
export default {
  components: {
    DateField
  },
  data: () => ({
    load_options: null,
    type: 'month',
    type_options: [
      { value: 'month', label: 'Month'},
      { value: 'week', label: 'Week'},
      { value: 'day', label: 'Day'},
    ],
    today: '',
    focus: '',
    event_items: [],
    repeat_options: [
      {text: 'Do not repeat', value: 'no_repeat'},
      // {text: 'Daily (Every day)', value: 'daily'},
      // {text: 'Weekday (Mon to Fri)', value: 'weekday'},
      {text: 'Repeat weekly', value: 'weekly'},
      // {text: 'Monthly (This day in every month)', value: 'monthly'},
    ],
    create_item_dialog: false,
    create_item: null,
    item_type_options: [
      {text: 'Available', value: 'available'},
      {text: 'Busy', value: 'busy'},
    ],
    selected_item: null,
    selected_item_dialog: false,
  }),
  computed: {
    events: function () {
      let items = []
      if(this.event_items && this.event_items.length > 0) {
        let mapped_items = this.event_items.map(item => ({...item, name: item.time_start + ' - ' + item.time_end}))
        items.push(...mapped_items)
      }
      return items
    }
  },
  created() {
    this.today = this.$currentTime().format('YYYY-MM-DD')
    this.focus = this.$currentTime().format('YYYY-MM-DD')
  },
  methods: {
    loadEvents({start, end}) {
      this.load_options = {start, end}
      this.axios.post('api/user/work-times', {date_from: start.date, date_to: end.date})
          .then(({data}) => { this.event_items = data.data })
    },
    setToday() {
      this.today = this.$currentTime().format('YYYY-MM-DD')
      this.focus = this.$currentTime().format('YYYY-MM-DD')
    },
    viewMore({date}) {
      this.focus = date
      this.type = 'day'
    },
    // getEventColor(session) {
    //   return session.color ? session.color : 'primary'
    // },
    getEventColor(event) {
      let diff = this.$moment(event.end).diff(this.$currentTime().format())
      return diff > 0 ? 'primary' : 'secondary'
    },
    openCreateItemDialog(interval) {
      let end = this.$moment.duration(interval.time).add(90, 'minutes')
      this.create_item = {
        ...this.create_item,
        name: '',
        repeat: 'no_repeat',
        type: 'available',
        weekday: interval.weekday,
        date: interval.date,
        time_start: interval.time,
        time_end: this.$moment.utc(end.asMilliseconds()).format("HH:mm"),
        repeat_start: interval.date,
        repeat_end: this.$moment(interval.date).add(3, 'months').format('YYYY-MM-DD'),
      }
      this.create_item_dialog = true
    },
    closeCreateItemDialog() {
      this.create_item_dialog = false
      this.create_item = null
    },
    saveCreateItem(e) {
      e.preventDefault()
      let repeat = this.create_item.repeat !== 'no_repeat'
      this.axios.post('api/user/work-times/create', {
        repeat: this.create_item.repeat,
        repeat_start: repeat ? this.create_item.repeat_start : null,
        repeat_end: repeat ? this.create_item.repeat_end : null,
        type: this.create_item.type,
        // timezone: this.new_work_time.timezone,
        weekday: this.create_item.weekday,
        date: this.create_item.date,
        time_start: this.create_item.time_start,
        time_end: this.create_item.time_end,
      })
          .then(() => {
            this.closeCreateItemDialog()
            this.loadEvents(this.load_options)
          })
    },
    openSelectedItemDialog({event}) {
      this.selected_item = event
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null

    },
    saveSelectedItemChanges(e) {
      e.preventDefault()
    },
    deleteSelectedItem(opts) {
      this.axios.post('api/user/work-times/delete', {
        work_time_id: this.selected_item.id,
        delete_type: opts,
        date: this.selected_item.date,
      })
          .then(() => {
            this.closeSelectedItemDialog()
            this.loadEvents(this.load_options)
          })
    }
  }
}
</script>